// src/modules/reports/components/table/ReportTable.tsx
import { Report } from "../../models/report.model";
import ReportTableRow from "./ReportTableRow";

interface ReportTableProps {
  reportList: Report[];
}

export default function ReportTable({ reportList }: ReportTableProps) {
  return (
    <div className="table-responsive shadow-sm border rounded">
      <table className="table table-hover align-middle mb-0">
        <thead className="table-light">
          <tr>
            <th>Nội Dung | Người Dùng</th>
            <th>Loại</th>
            <th>Trạng Thái</th>
            <th>Hành động đã thực hiện</th>
            <th>Ngày tạo</th>
            <th>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {reportList.map((report) => (
            <ReportTableRow key={report.id} report={report} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
